module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.eacc609.woff2";